import { HttpMethod } from '../../types.js';
export const ApiDef_BackupDoc = {
    _v1: {
        initiateBackup: { method: HttpMethod.GET, path: 'v1/initiate-backup-v2' },
        fetchBackupDocs: { method: HttpMethod.GET, path: 'v1/fetch-backup-docs-v2' },
    }
};
//# sourceMappingURL=api-def.js.map